var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
import React from 'react';
import {
  ALIGN,
  CLR,
  CONTENT,
  ITEMS,
  JUSTIFY,
  LG,
  MD,
  ROW,
  SM,
  XL
} from '../../constants';
import classes from '../../utils/classes';
import cssPrefix from '../../utils/cssPrefix';
import withMemoRef from '../../utils/withMemoRef';
/**
 * Row align prefix.
 */
const rowAlignPrefix = cssPrefix(CLR, ALIGN, ITEMS);
/**
 * Row sm align prefix.
 */
const rowAlignSmPrefix = cssPrefix(CLR, ALIGN, ITEMS, SM);
/**
 * Row md align prefix.
 */
const rowAlignMdPrefix = cssPrefix(CLR, ALIGN, ITEMS, MD);
/**
 * Row lg align prefix.
 */
const rowAlignLgPrefix = cssPrefix(CLR, ALIGN, ITEMS, LG);
/**
 * Row xl align prefix.
 */
const rowAlignXlPrefix = cssPrefix(CLR, ALIGN, ITEMS, XL);
/**
 * Row justify-content prefix.
 */
const rowJustifyContentPrefix = cssPrefix(CLR, JUSTIFY, CONTENT);
/**
 * Row sm justify-content prefix.
 */
const rowJustifyContentSmPrefix = cssPrefix(CLR, JUSTIFY, CONTENT, SM);
/**
 * Row md justify-content prefix.
 */
const rowJustifyContentMdPrefix = cssPrefix(CLR, JUSTIFY, CONTENT, MD);
/**
 * Row lg justify-content prefix.
 */
const rowJustifyContentLgPrefix = cssPrefix(CLR, JUSTIFY, CONTENT, LG);
/**
 * Row xl justify-content prefix.
 */
const rowJustifyContentXlPrefix = cssPrefix(CLR, JUSTIFY, CONTENT, XL);
/**
 * Row component.
 *
 * @param props Row properties.
 */
export const Row = withMemoRef('Row', (_a, ref) => {
  var {
      align,
      alignLg,
      alignMd,
      alignSm,
      alignXl,
      alignXs,
      className,
      justify,
      justifyLg,
      justifyMd,
      justifySm,
      justifyXl,
      justifyXs
    } = _a,
    props = __rest(_a, [
      'align',
      'alignLg',
      'alignMd',
      'alignSm',
      'alignXl',
      'alignXs',
      'className',
      'justify',
      'justifyLg',
      'justifyMd',
      'justifySm',
      'justifyXl',
      'justifyXs'
    ]);
  return React.createElement(
    'div',
    Object.assign(
      {
        className: classes(
          [CLR, ROW],
          {
            [rowAlignPrefix(align)]: align,
            [rowAlignPrefix(alignXs)]: alignXs,
            [rowAlignSmPrefix(alignSm)]: alignSm,
            [rowAlignMdPrefix(alignMd)]: alignMd,
            [rowAlignLgPrefix(alignLg)]: alignLg,
            [rowAlignXlPrefix(alignXl)]: alignXl
          },
          {
            [rowJustifyContentPrefix(justify)]: justify,
            [rowJustifyContentPrefix(justifyXs)]: justifyXs,
            [rowJustifyContentSmPrefix(justifySm)]: justifySm,
            [rowJustifyContentMdPrefix(justifyMd)]: justifyMd,
            [rowJustifyContentLgPrefix(justifyLg)]: justifyLg,
            [rowJustifyContentXlPrefix(justifyXl)]: justifyXl
          },
          className
        )
      },
      Object.assign(Object.assign({}, props), { ref })
    )
  );
});
export default Row;
